import { useCallback, useEffect, useState } from "react";
import {
	LANGUAGE_STORAGE_KEY,
	getStoredLanguage,
	translate,
} from "../utils/i18n";

// Subscribes to the app's current UI language and provides a `t()` translator.
//
// The language is set by the Header language selector, which persists it to
// localStorage and dispatches a `languagechange` event. This hook also listens
// to the native `storage` event so changes in another tab are reflected too.
export function useLanguage() {
	const [language, setLanguage] = useState(() => getStoredLanguage());

	useEffect(() => {
		const handleLanguageChange = (event) => {
			const next = event?.detail?.language ?? getStoredLanguage();
			setLanguage(next);
		};
		const handleStorage = (event) => {
			if (event.key === LANGUAGE_STORAGE_KEY) {
				setLanguage(getStoredLanguage());
			}
		};

		window.addEventListener("languagechange", handleLanguageChange);
		window.addEventListener("storage", handleStorage);
		return () => {
			window.removeEventListener("languagechange", handleLanguageChange);
			window.removeEventListener("storage", handleStorage);
		};
	}, []);

	const t = useCallback(
		(key, vars) => translate(language, key, vars),
		[language],
	);

	return { language, t };
}

export default useLanguage;
